export enum RoleEnum {
	engineer = 3, //Инженер СЦ
	partnerServiceCenterEngineer = 9, //Инженер СЦ партнера
	storekeeper = 10, // Сотрудник склада
	selfEmployedEngineer = 13 //Самозанятый инженер
}